<template>
  <div
    v-loading="loading"
    class="grid-view"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div class="main-content">
      <div class="section operations">
        <div class="triggers">
          <div style="display: inline-block;">
            <span class="input-label">{{ $t('CargoMsg.Cargo_ClosingMonth') }}</span>
            <el-select v-model="closingDate" style="width: 120px;" filterable>
              <el-option v-for="(item,index) in accMonths" :key="index" :label="item.label" :value="item.value" />
            </el-select>
            <el-button type="primary" style="margin-left: 50px;" @click="queryTenantClosingAccount">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            <el-button type="primary" @click="verifyMouseEventHandler">{{ $t('CargoMsg.Cargo_BatchAudit') }}</el-button>
            <el-button type="primary" @click="cancelVerifyBtnMouseEventHandler">{{ $t('CargoMsg.Cargo_CancelAudit') }}</el-button>
          </div>
        </div>
      </div>
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        class="section grid-wrapper"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { deepCopy } from '@/utils/commonUtil'
import { queryCurrentTenantClosingAccount, batchSaveClosingAccount, queryAllClosingAccountYear } from '@/api/act/closingAccount'

export default {
  name: 'CloseAccount',
  data() {
    return {
      loading: false,
      accMonths: [],
      closingDate: '',
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_AccountKeeper'),
          field: 'inputBy',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ClosingMonth'),
          field: 'closingDate',
          cellRenderer: params => {
            if (params.value) {
              return moment(params.value).format('YYYY-MM')
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ClosingBranch'),
          field: 'branchId',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationDate'),
          field: 'dateCreated',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Auditor'),
          field: 'verifiedBy',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AccountClosingType'),
          field: 'closingAccountType',
          cellRenderer: params => {
            return ColumnUtils.closingAccountTypeLabel(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  async created() {
    this.closingDate = ''
    const yearList = await queryAllClosingAccountYear().then(res => { return res.data })
    if (yearList && yearList.length > 0) {
      let maxYear = 0
      for (const year of yearList) {
        if (year) {
          if (year > maxYear) {
            maxYear = year
          }
          for (let i = 1; i <= 12; ++i) {
            this.accMonths.push({
              label: year + this.$t('Clearing.Year') + i + this.$t('Clearing.Month'),
              value: year + '-' + (i < 10 ? '0' : '') + i + '-01'
            })
          }
        }
      }
      if (maxYear) {
        this.closingDate = maxYear + '-12-01'
      }
    }
    if (this.closingDate) {
      this.queryTenantClosingAccount()
    }
  },
  methods: {
    queryTenantClosingAccount() {
      if (!this.closingDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_ClosingMonth'))
        return
      }
      this.loading = true
      queryCurrentTenantClosingAccount({ closingDate: this.closingDate }).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    verifyMouseEventHandler() {
      let items = this.gridApi.getSelectedRows().filter(p => p.verifiedBy === 0)
      if (items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      this.$confirm(this.$t('Message.CannotBeCancelledAfterApproval'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('Message.Yes'),
        cancelButtonText: this.$t('Message.No'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        items = deepCopy(items)
        for (const item of items) {
          item.verifiedBy = this.$store.getters.userInfo.userId
          item.verifyDate = moment().format('YYYY-MM-DD HH:mm:ss')
        }
        this.loading = true
        batchSaveClosingAccount(items).then(res => {
          this.$message.success(this.$t('Clearing.OperationSuccessful'))
          this.queryTenantClosingAccount()
        }).catch(() => {
          this.loading = false
        })
      }).catch(() => { })
    },
    cancelVerifyBtnMouseEventHandler() {
      let items = this.gridApi.getSelectedRows().filter(p => p.verifiedBy > 0)
      if (items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectRecord'))
        return
      }
      this.$confirm(this.$t('Message.ClosingDateAfterCancelingTheApproval'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('Message.Yes'),
        cancelButtonText: this.$t('Message.No'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        items = deepCopy(items)
        for (const item of items) {
          item.verifiedBy = 0
          item.verifyDate = ''
        }
        this.loading = true
        batchSaveClosingAccount(items).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          this.queryTenantClosingAccount()
        }).catch(() => {
          this.loading = false
        })
      }).catch(() => { })
    }
  }
}
</script>

<style scoped>
.input-label {
  display: inline-block;
  padding: 0 5px;
  color: #666666;
}
</style>
